import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export type DetachCreditsResponse = { data: { items: { cart: Cart } } };

const detachCredits = () => axios.delete<DetachCreditsResponse>(`${API_URLS.CART}cancel-credits`, {});

export default detachCredits;
